// extracted by mini-css-extract-plugin
module.exports = {"row":"SsSwitch_row__3uS4O","text":"SsSwitch_text__1hW79","text-ltr":"SsSwitch_text-ltr__3y1KF"};